export default {"src":"/_next/static/media/PPTX.adb62543.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};